import { render, staticRenderFns } from "./inputImgRadio.pug?vue&type=template&id=57631178&lang=pug&"
import script from "./inputImgRadio.js?vue&type=script&lang=js&"
export * from "./inputImgRadio.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57631178')) {
      api.createRecord('57631178', component.options)
    } else {
      api.reload('57631178', component.options)
    }
    module.hot.accept("./inputImgRadio.pug?vue&type=template&id=57631178&lang=pug&", function () {
      api.rerender('57631178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/modules/imgRadio/index.vue"
export default component.exports